export { DETAILS_DIRECTIVE_NAME, COMPONENTS_MODULE_NAME } from './route.components.module'